import { useState } from 'react';

export function useShowMore<T>(items: T[], initialDisplayCount: number) {
  const canShowMore = items.length > initialDisplayCount;

  const [showMore, setShowMore] = useState(false);

  const visibleItems = showMore ? items : items.slice(0, initialDisplayCount);

  const toggleShowMore = () => setShowMore(!showMore);

  return { canShowMore, visibleItems, showMore, toggleShowMore };
}
